import { index } from 'd3'

/**
 * Takes an array and adds new entries to it if they are not already present.
 * @param {Array<{uniqueKey: string}>} array
 * @param {Array<{uniqueKey: string}>} newEntries
 * @param {string} uniqueKey
 */
export function addNewEntries (array, newEntries, uniqueKey) {
  const currentMap = index(array, d => d[uniqueKey])

  for (const newEntry of newEntries) {
    if (!currentMap.get(newEntry[uniqueKey])) {
      array.push(newEntry)
    }
  }
}
